import {
  parseInventoryBoxIdFromScan,
  parseInventoryLocationUrl,
} from "@integrator-src/api/inventory-box/inventory-box-scan";

export type WarehouseRecountScan =
  | { kind: "box"; hex: string }
  | { kind: "location_tag"; sku: string; megaventoryLocationId: number }
  | { kind: "sku"; sku: string };

export function parseWarehouseRecountScan(raw: string): WarehouseRecountScan | null {
  const trimmed = raw.trim();
  if (trimmed === "") return null;

  const boxHex = parseInventoryBoxIdFromScan(trimmed);
  if (boxHex != null) {
    return { kind: "box", hex: boxHex };
  }

  const locationTag = parseInventoryLocationUrl(trimmed);
  if (locationTag != null) {
    return {
      kind: "location_tag",
      sku: locationTag.sku,
      megaventoryLocationId: locationTag.locationId,
    };
  }

  if (/^https?:\/\//iu.test(trimmed)) return null;
  if (trimmed.includes("/") || trimmed.includes(" ")) return null;
  if (trimmed.length < 2 || trimmed.length > 80) return null;
  return { kind: "sku", sku: trimmed };
}
